/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
export * from './si-icon.module';
export * from './status-icon';
export { addIcons } from './si-icons';
export * from './si-icon.component';
export * from './si-icon-legacy.component';
export * from './si-status-icon.component';
export { elementCheckedImageShape } from './element-icons';
